export enum AppStorageScopeEnum {
  GLOBAL = "global",
  AUTH = "auth",
  USER = "user",
  DEVICE = "device",
}
